import { Component, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as _ from 'lodash';
import { Observable, of } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, shareReplay, switchMap } from 'rxjs/operators';
import { GeopathSegment } from '../../models/impressions';

@Component({
  selector: 'core-choose-segment',
  templateUrl: './choose-segment.component.html',
  styleUrls: ['./choose-segment.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ChooseSegmentComponent,
      multi: true,
    },
  ],
})
export class ChooseSegmentComponent implements OnInit {
  public filteredSegments: Observable<GeopathSegment[]>;
  public control = new FormControl('');
  public onTouched = _.noop;
  private onChange = _.noop;
  private last: GeopathSegment | null;

  constructor(private apollo: Apollo) {}

  ngOnInit() {
    this.filteredSegments = this.control.valueChanges.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      switchMap((path) => this.querySegments(path)),
      shareReplay(1)
    );

    this.control.valueChanges.subscribe((value) => {
      if (_.isObject(value)) {
        this.setValue(<GeopathSegment>value);
      } else if (!!this.last && this.last.name !== value) {
        this.setValue(null);
      }
    });
  }

  private setValue(value: GeopathSegment | null): void {
    this.last = value;
    this.onChange(value);
  }

  public clear() {
    this.control.patchValue('');
  }

  public writeValue(segment: GeopathSegment | null): void {
    this.control.setValue((this.last = segment));
  }
  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
  public setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.control.disable() : this.control.enable();
  }

  public display(segment?: GeopathSegment) {
    return segment ? segment.name : undefined;
  }

  private querySegments(text: string): Observable<GeopathSegment[]> {
    return text.length >= 3
      ? this.apollo
          .query({
            query: gql`
              query GeopathSegments($text: String!) {
                allGeopathSegments(first: 100, text: $text) {
                  edges {
                    node {
                      name
                      id
                    }
                  }
                }
              }
            `,
            variables: { text },
          })
          .pipe(map((result) => _.map(_.get(result, 'data.allGeopathSegments.edges'), 'node')))
      : of([]);
  }
}
